import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { StoreState } from '../../reducers/index';

import { Container, CloseButton } from './styles';
import Utils from '../../utils';
import { AppInfosActionKeys } from '../App/actions';
const Translate = require('react-redux-i18n').Translate;

interface CookieNotificationProps {
	display: boolean;
	dispatch: Dispatch<StoreState>;
}

class CookieNotification extends React.Component<CookieNotificationProps, {}> {
	constructor(props: CookieNotificationProps) {
		super(props);
		this.acceptCookie = this.acceptCookie.bind(this);
	}

	acceptCookie() {
		const { dispatch } = this.props;
		Utils.setCookie('areCookieAccepted', 'true', 90);
		dispatch({ type: AppInfosActionKeys.ACCEPT_COOKIE });
	}

	render() {
		const { display } = this.props;
		return (
			<Container shouldDisplay={display}>
				<CloseButton onClick={this.acceptCookie}>
					{Utils.getSvgIcon('iconset_close-2')}
				</CloseButton>
				<Translate
					value="messages.cookie_notification"
					dangerousHTML={true}
				/>
			</Container>
		);
	}
}

export default connect()(CookieNotification);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/CookieNotification/index.tsx